(function() {
  if (window.caleoProductFeatureIconsReady) return;
  window.caleoProductFeatureIconsReady = true;

  function initTrack(track) {
    if (!track || track.dataset.caleoDragReady === 'true') return;
    track.dataset.caleoDragReady = 'true';

    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;

    track.addEventListener('mousedown', function(event) {
      if (event.button !== 0) return;
      isDown = true;
      moved = false;
      startX = event.pageX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    window.addEventListener('mouseup', function() {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', function(event) {
      if (!isDown) return;
      var distance = event.pageX - startX;
      if (Math.abs(distance) > 4) moved = true;
      event.preventDefault();
      track.scrollLeft = startScrollLeft - distance;
    });

    track.addEventListener('click', function(event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-caleo-feature-icons-track]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
